import { OrderSource, OrderSubType } from '../../account/orders/types';

export const getOrderHrefLink = (
    subType: OrderSubType,
    orderSource: string | undefined,
    orderNumber: string,
) => {
    if (orderSource === OrderSource.SOM) {
        return 'https://mnsnoa-nintendo.my.salesforce.com';
    }
    if (subType === OrderSubType.ESHOP) {
        return `https://pit.mng.nintendo.net/pit/transaction/search?eciTransactionId=${orderNumber}`;
    }
    return '';
};
